// components/AuthInitializer.js
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { logout, setUser } from "../../store/authSlice";
import { useNavigate } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_URL
const AuthInitializer = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate=useNavigate();

  useEffect(() => {
    const refreshSession = async () => {
      try {
        const res = await axios.post(`${API_BASE_URL}/api/auth/refresh-token`,{}, { withCredentials: true });
        
        if(res.status === 200){
            const user = res?.data?.user;
            dispatch(setUser({user,accessToken:user.token }));
        }
      } catch (err) {
        dispatch(logout());
        navigate('/login');
      }finally {
        setLoading(false);
      }
    };

    refreshSession();
  }, [dispatch]);

  if (loading) return <div>Loading...</div>; // Or a loading spinner

  return children;
};

export default AuthInitializer;
